export default "__VITE_ASSET__CPN0Zry4__"